import { ModelBase } from 'store/model-base';
import { CmsQuickpayBreadcrumbs } from './quickpay-breadcrumbs';

export class CmsUserQuickpay extends ModelBase {
    public static storeName: string = 'cmsUserQuickpay';

    public start: CmsQuickpayStart;
    public summary: CmsQuickpaySummary;
    public card: CmsQuickpayCard;
    public amount: CmsQuickpayAmount;
    public success: CmsQuickPaySuccess;
    public review: CmsQuickpayReview;
    public timeoutWarningModal: DescriptiveModalData;
    public timeoutConfirmationModal: DescriptiveModalData;
    public homepageUrl: string;
    public breadcrumb: CmsQuickpayBreadcrumbs;
}
